import React, { Component, Fragment } from 'react'
import StatusPageMixin from 'containers/shared/StatusPageMixin'
import { connect } from 'react-redux'
import { TokenActions, UserActions } from 'actionsets'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import StyleSheet from 'styles'
import LockIcon from '@material-ui/icons/Lock'

export class Enable2fa extends StatusPageMixin(Component){
  constructor(props) {
    super(props)
    TokenActions.bindActions(this)
    UserActions.bindActions(this, 'user')
  }

  handleSkip = async() => {
    await this.actions.user.update({id: this.props.currentUser.id, otpRequiredForLogin: false})
    await this.actions.verify()
    this.props.history.push('/')
  }

  body = () =>
    <Fragment>
      <Typography variant='h6'>Enable Two Factor Authentication (2FA)</Typography>
      <LockIcon className={styles.lockIcon} />
      <Typography variant='body1' paragraph>We recommend you secure your account with two-factor authentication</Typography>
      <Typography variant='body2' paragraph>
        Two factor authentication (2FA) uses one-time passwords, generated on your phone, each time you sign in to
        provide additional security for your account
      </Typography>
      <div className={styles.buttonBar}>
        <Button fullWidth variant='contained' color="primary" onClick={() => this.props.history.push('/tokens/enable_2fa')}>Enable 2FA</Button>
        <Button fullWidth variant='contained' color="secondary" onClick={this.handleSkip}>Skip</Button>
      </div>
    </Fragment>
}


const styles = StyleSheet({
  buttonBar: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    margin: [20, -5],
    '& button': {
      margin: [0, 5]
    }
  },
  lockIcon: {
    width: 96,
    height: 96,
    display: 'block',
    margin: [30, 'auto']
  }
})
export default connect(({tokens}) => tokens)(Enable2fa)